import React from "react";
import "./dhipaya_truck.css";

export default function DhipayaTruckDetails({ onQuote }) {
  const rows = [
    { code: "320", name: "รถบรรทุกใหญ่ 4–12 ตัน", noEquip: "8,000", equip: "9,000" },
    { code: "327", name: "รถลากจูง เพื่อการพาณิชย์", noEquip: "10,000", equip: "11,000" },
    { code: "340", name: "รถบรรทุกวัตถุอันตราย", noEquip: "12,000", equip: "15,000" },
    { code: "347", name: "รถลากจูงพิเศษ", noEquip: "14,000", equip: "16,900" },
    { code: "420", name: "รถหัวลาก", noEquip: "20,000", equip: "24,000" },
    { code: "520", name: "รถหางพ่วง (น้ำมัน/ก๊าซ)", noEquip: "10,000", equip: "13,000" },
    { code: "540", name: "หางพ่วง วัตถุอันตราย", noEquip: "10,000", equip: "13,000" },
  ];

  return (
    <div className="pkg-detail dhipaya-truck">
      <h2>ตารางเบี้ย ประเภท 3 รถใหญ่ ทิพยประกันภัย</h2>

      <table className="pkg-table">
        <thead>
          <tr>
            <th>รหัส</th>
            <th>ประเภทรถ</th>
            <th>ไม่มีอุปกรณ์ (บาท)</th>
            <th>มีอุปกรณ์ (บาท)</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.code}>
              <td>{r.code}</td>
              <td>{r.name}</td>
              <td>{r.noEquip}</td>
              <td>{r.equip}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pkg-foot">
        <p>รวมภาษี / อากร แล้ว • อายุรถ ≤ 15 ปี • เฉพาะรถเชิงพาณิชย์</p>
        <button className="pkg-quote-btn" onClick={onQuote}>ขอใบเสนอราคา</button>
      </div>
    </div>
  );
}
